import styled from '@emotion/styled'
import {theme} from '../../features/Dashboard/theme'

export const CardTop = styled.div`
  padding: 20px 20px 18px;
  border-bottom: 1px solid ${theme.colors.border};
  background-color: #ffffff;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 0;
  ${props =>
    props.selectable &&
    `
    cursor: pointer;
    width: 100%;
    max-width: 320px;
  `}
  ${props =>
    props.selected &&
    `
    background: #F4F6FB;
    border: 1px solid #6967EE;
    box-shadow: 0 4px 5.9px 0 rgba(0, 0, 0, 0.12);
  `}

  @media (max-width: 600px) {
    padding: 14px 14px 12px;
  }
`

export const CenterGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: ${props => (props.align === 'left' ? 'left' : 'center')};
  width: 100%;
  min-width: 0;
  /* Prevent OptionName from sliding under the absolute SelectionIndicator */
  padding: 0 34px;

  @media (max-width: 600px) {
    padding: 0 28px;
  }
`

/* Shown only in selectable mode */
export const SelectionIndicator = styled.button`
  position: absolute;
  top: 14px;
  left: 14px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid ${props => (props.selected ? '#5378fc' : '#d1d5db')};
  background: ${props => (props.selected ? '#5378fc' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  padding: 0;
  flex-shrink: 0;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:focus {
    outline: none;
  }
`

/* Default mode only */
export const OptionLabel = styled.p`
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 500;
  color: ${theme.colors.primary};
  font-family: ${theme.font.family};
  font-style: italic;
`

export const OptionNameRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;

  h3 {
    margin-bottom: 0;
  }
`

export const OptionName = styled.h3`
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 800;
  font-style: italic;
  color: ${theme.colors.primary};
  font-family: ${theme.font.family};
  overflow-wrap: anywhere;
  word-break: break-word;

  @media (max-width: 600px) {
    font-size: 18px;
  }
`

export const StarsWrap = styled.span`
  display: inline-flex;
  gap: 4px;
  align-items: center;
  margin-bottom: 10px;
`

export const DueTodayLabel = styled.p`
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  color: ${theme.colors.text};
  font-family: ${theme.font.family};
`

export const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  justify-content: flex-start;
  margin-bottom: 14px;
  flex-direction: column;
`

export const TotalPrice = styled.p`
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  color: ${theme.colors.primary};
  font-family: ${theme.font.family};
  letter-spacing: -0.01em;

  @media (max-width: 600px) {
    font-size: 22px;
  }
`

export const MonthlyText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.text};
  font-family: ${theme.font.family};
  white-space: nowrap;

  strong {
    font-size: 14px;
    font-weight: 700;
  }
`
